import * as io from "socket.io-client";
import { refreshAccessToken } from "@/api/AuthAPI/auth-request-api";

interface IwsDone {
  image: string;
  name: string;
}

export class FileRender {
  selectedFile: File | null = null;
  socket: io.Socket | null = null;
  FReader = new FileReader();
  typeParams = "video";
  path = "";
  uri = "";

  progress = {
    value: 0,
  };

  constructor(file: File, path: string, uri: string, upload: string) {
    this.selectedFile = file;
    this.path = path;
    this.uri = uri;
    this.typeParams = upload;
  }

  async connect(): Promise<void> {
    const auth = { token: `Bearer ${localStorage.getItem("access")}` };
    const base = this.path
      ? { query: { x: this.typeParams, path: this.path }, auth }
      : { query: { x: this.typeParams }, auth };
    this.socket = /^(https?:)?\/\//i.test(this.uri)
      ? io.connect(this.uri, base)
      : io.connect({ ...base, path: this.uri });
    this.wsMoreData();
    this.wsError();
    this.wsDone();
  }

  startUpload(): void {
    if (!this.socket || !this.selectedFile) return;

    const size = this.selectedFile.size;

    this.FReader.onload = (evnt) => {
      if (!this.socket) return;
      this.socket.emit("Upload", {
        name: this.selectedFile?.name,
        data: evnt?.target?.result,
      });
    };
    this.socket.emit("Start", { name: this.selectedFile?.name, size });
  }

  wsMoreData(): void {
    if (!this.socket) return;
    this.socket.on("MoreData", (data) => {
      if (!this.selectedFile) return;
      this.progress.value = data["percent"];

      const event = new CustomEvent("progress", {
        detail: {
          name: this.selectedFile?.name,
          progress: this.progress.value,
        },
      });
      document.dispatchEvent(event);

      const place = data["place"] * 524288;
      let newFile;
      // eslint-disable-next-line
      // @ts-ignore
      if (this.selectedFile.webkitSlice)
        // eslint-disable-next-line
        // @ts-ignore
        newFile = this.selectedFile.webkitSlice(
          place,
          place + Math.min(524288, this.selectedFile.size - place)
        );
      else
        newFile = this.selectedFile.slice(
          place,
          place + Math.min(524288, this.selectedFile.size - place)
        );
      this.FReader.readAsBinaryString(newFile);
    });
  }

  wsError(): void {
    if (!this.socket) return;
    this.socket.on("401", () => {
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
      refreshAccessToken().then(
        (res: { access: string; refreshtoken: string } | undefined) => {
          if (!res) return;
          this.connect();
        }
      );
    });
    this.socket.on("403", () => {
      alert("403");
    });
  }

  wsDone(): void {
    if (!this.socket) return;
    this.socket.on("Done", (data: IwsDone) => {
      this.progress.value = 100;
      console.log("Done");
      const event = new CustomEvent("done", {
        detail: this.selectedFile?.name,
      });
      document.dispatchEvent(event);
    });
  }
}
